import { render, staticRenderFns } from "./logo-only.vue?vue&type=template&id=b20a65c4&scoped=true&"
import script from "./logo-only.vue?vue&type=script&lang=js&"
export * from "./logo-only.vue?vue&type=script&lang=js&"
import style0 from "./logo-only.vue?vue&type=style&index=0&id=b20a65c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20a65c4",
  null
  
)

export default component.exports